import React from 'react';
import { Button } from '@/components/ui/button';
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateMessage,
  EmptyStateActions,
} from '../styles';
import { BriefcaseIcon, UsersIcon, PlusIcon, PlugIcon } from '../utils/iconMapping';

interface EmptyStateCardProps {
  type: 'roles' | 'candidates';
  hasAtsConnection: boolean;
  canImport: boolean;
  onAddManually: () => void;
  onImportFromAts?: () => void;
}

export function EmptyStateCard({
  type,
  hasAtsConnection,
  canImport,
  onAddManually,
  onImportFromAts,
}: EmptyStateCardProps) {
  const isRoles = type === 'roles';

  return (
    <EmptyStateContainer>
      <EmptyStateIcon>
        {isRoles ? <BriefcaseIcon /> : <UsersIcon />}
      </EmptyStateIcon>
      <EmptyStateTitle>
        {isRoles ? 'No Roles Yet' : 'No Candidates Yet'}
      </EmptyStateTitle>
      <EmptyStateMessage>
        {isRoles
          ? hasAtsConnection
            ? 'You have connected your ATS. Import roles or add them manually to get started.'
            : 'Add your first role to start building your pipeline.'
          : hasAtsConnection
          ? 'You have connected your ATS. Import candidates or add them manually to get started.'
          : 'Add your first candidate to start building your talent pool.'}
      </EmptyStateMessage>
      <EmptyStateActions>
        <Button onClick={onAddManually}>
          <PlusIcon style={{ marginRight: '0.5rem' }} />
          Add {isRoles ? 'Role' : 'Candidate'} Manually
        </Button>
        {hasAtsConnection && canImport && onImportFromAts && (
          <Button variant="outline" onClick={onImportFromAts}>
            <PlugIcon style={{ marginRight: '0.5rem' }} />
            Import from ATS
          </Button>
        )}
      </EmptyStateActions>
    </EmptyStateContainer>
  );
}
